import { Button } from "./ui/button";
import { motion } from "framer-motion";

export function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-white via-orange-50 to-orange-100">
      {/* Abstract Background Shapes */}
      <div className="absolute inset-0">
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 0.1, scale: 1 }}
          transition={{ duration: 2, ease: "easeOut" }}
          className="absolute top-20 left-10 w-96 h-96 bg-orange-600 rounded-full blur-3xl"
        />
        <motion.div
          initial={{ opacity: 0, x: -100 }}
          animate={{ opacity: 0.15, x: 0 }}
          transition={{ duration: 2, delay: 0.5 }}
          className="absolute bottom-20 right-20 w-80 h-80 bg-orange-800 rounded-full blur-3xl"
        />
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 0.1, y: 0 }}
          transition={{ duration: 2, delay: 1 }}
          className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gradient-to-r from-orange-500 to-orange-700 rounded-full blur-3xl"
        />
      </div>

      {/* Background Images Collage */}
      <div className="absolute inset-0 opacity-10">
        <div className="grid grid-cols-6 grid-rows-4 h-full gap-4 p-8">
          <div className="col-span-2 row-span-2 rounded-lg overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=300&fit=crop" 
              alt="Team collaboration" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="col-span-1 row-span-1 rounded-lg overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=200&h=200&fit=crop" 
              alt="Analytics dashboard" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="col-span-2 row-span-1 rounded-lg overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=400&h=200&fit=crop" 
              alt="Event activation" 
              className="w-full h-full object-cover"
            />
          </div>
          <div className="col-span-1 row-span-2 rounded-lg overflow-hidden">
            <img 
              src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=200&h=400&fit=crop" 
              alt="Mobile app interface" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.2 }}
        >
          <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight">
            AdHub — <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-600 to-orange-800">Connect brands,</span><br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-800 to-orange-600">activate growth</span>
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          <p className="text-xl md:text-2xl text-gray-600 mb-12 max-w-4xl mx-auto leading-relaxed">
            Integrated online + offline + tech-driven content solutions to accelerate business growth.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          <Button 
            size="lg" 
            className="text-lg px-8 py-6 bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
          >
            Get Free Consultation
          </Button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 1.5 }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
          className="w-6 h-10 border-2 border-gray-400 rounded-full flex justify-center"
        >
          <div className="w-1 h-3 bg-gray-400 rounded-full mt-2"></div>
        </motion.div>
      </motion.div>
    </section>
  );
}